import { isObjectEmpty } from '../common/utils/productCardProps';
export const validateAvailabilityTranslation = availabilityProps => {
  try {
    if (isObjectEmpty(availabilityProps)) {
      return false;
    }
    const {
      availabilityCard
    } = availabilityProps;
    if (isObjectEmpty(availabilityCard)) {
      return false;
    }
    const {
      availabilityTitle,
      departing,
      return: returnKey,
      availableStatus,
      unavailableStatus,
      addedStatus,
      statusTooltip,
      addedTitle,
      seeAll
    } = availabilityCard;
    return Boolean(availabilityTitle && departing && returnKey && availableStatus && unavailableStatus && addedStatus && statusTooltip && addedTitle && seeAll);
  } catch (error) {
    return false;
  }
};
//# sourceMappingURL=utils.js.map